import CostsStockAndBase from './CostsStockAndBase'

export default CostsStockAndBase
